import {
  fetchUserReplyTemplates,
  type TUserReplyTemplatesResponse,
} from '../../repositories/chats/v1/user-reply-templates';

import type { IErrorResponseSchema } from '../../repositories/chats/entities/schemas/ErrorResponseSchema';
import type { IApplicationContext } from '../../types/applicationContext';
import type { FetchResponse } from '@cian/http-api';

export async function fetchUserReplyTemplatesPublic(context: IApplicationContext) {
  const { httpApi, logger } = context;

  try {
    const { response, statusCode }: FetchResponse<TUserReplyTemplatesResponse> = await fetchUserReplyTemplates({
      httpApi,
    });

    if (statusCode !== 200) {
      throw new Error((response as IErrorResponseSchema)?.message);
    }

    return response;
  } catch (e) {
    logger.error(e, {
      domain: 'src/shared/services/replyTemplates/fetchUserReplyTemplatesPublic.ts',
      description: 'Ошибка получения списка шаблонов ответов',
    });

    throw e;
  }
}
